import React, { FC } from 'react';

import { useInsuranceLabels } from '../../../Utils/Context/labelsContext';

import { ButtonTier, ButtonType } from '../../../Partials/Button';
import { Link } from '../../../Partials/Link';
import { StreamLineIcons, StreamLineIcon } from '../../../../SvgIcon/StreamLineIcon'

import { DoctorBarStatus } from '../Types/types';

interface DoctorBarTreaterButtonProps {
  barState: DoctorBarStatus;
  doctorUrl: string;
}

export const DoctorBarTreaterButton: FC<DoctorBarTreaterButtonProps> = (props) => {
  const { barState, doctorUrl } = props;

  const {
    buttons
  } = useInsuranceLabels();

  const controlsVariant = (status: DoctorBarStatus): {
    icon: StreamLineIcons,
    label: string;
    href: string;
    buttonTier?: ButtonTier,
    buttonType?: ButtonType,
  } => {
    switch (status) {
      case 'noFilters':
      case 'loading':
        return {
          buttonTier: 'tertiary',
          buttonType: 'solid',
          icon: 's-arrow-right-dash',
          label: buttons.readMoreButtonLabel,
          href: doctorUrl
        }
      case 'withFilters':
        return {
          buttonTier: 'tertiary',
          buttonType: 'solid',
          icon: 's-arrow-right-dash',
          label: buttons.requestBookingButtonLabel,
          href: doctorUrl
        }
    }
  }

  const {
    icon,
    label,
    ...linkProps
  } = controlsVariant(barState);

  return (
    <div className="doctorBar__controls">
      <Link
        className='doctorBar__button'
        type='button'
        {...linkProps}
      >
        <StreamLineIcon
          className='doctorBar__buttonIcon'
          iconName={icon}
        />
        <span className='doctorBar__buttonLabel'>
          {label}
        </span>
      </Link>
    </div>
  )
};
